<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="getViewBox"
    :aria-labelledby="iconName"
    role="presentation"
    fill="none"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g :stroke="strokeColor" :fill="fillColor">
      <component :is="component"></component>
    </g>
  </svg>
</template>

<script>
import GiftIcon from './GiftIcon.vue';
import ChevronIcon from './ChevronIcon.vue';
import CheckmarkIcon from './CheckmarkIcon.vue';
import WarningIcon from './WarningIcon.vue';
import LoadingIcon from './LoadingIcon.vue';
import ArrowIcon from './ArrowIcon.vue';

export default {
  computed: {
    getViewBox() {
      return `0 0 ${this.width} ${this.height}`;
    },
    component() {
      const mapIcon = {
        Gift: GiftIcon,
        Chevron: ChevronIcon,
        Checkmark: CheckmarkIcon,
        Warning: WarningIcon,
        Loading: LoadingIcon,
        Arrow: ArrowIcon,
      };
      return mapIcon[this.iconName];
    },
  },
  props: {
    iconName: {
      type: String,
      required: true,
      validator(value) {
        return [
          'Gift',
          'Chevron',
          'Checkmark',
          'Warning',
          'Loading',
          'Arrow',
        ].includes(value);
      },
    },
    width: {
      type: Number,
      default: 21,
    },
    height: {
      type: Number,
      default: 21,
    },
    fillColor: {
      type: String,
      default: 'none',
    },
    strokeColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
